/** Structured speaking latency markers — no transcript/PII in payloads. */

export type SpeakingLatencyMarker =
  | 'T1_LAST_FINAL_TRANSCRIPT'
  | 'T1_SILENCE_GATE_ELAPSED'
  | 'T1_GENERATE_QUESTION_SENT'
  | 'T1_AI_RESPONSE_RECEIVED'
  | 'T1_AUDIO_DECODE_READY'
  | 'T1_AUDIO_PLAYBACK_STARTED'
  | 'T3_SILENCE_STARTED'
  | 'T3_NUDGE_PREFETCH_SENT'
  | 'T3_NUDGE_RESPONSE_RECEIVED'
  | 'T3_NUDGE_AUDIO_READY'
  | 'T3_NUDGE_PLAYBACK_STARTED'
  | 'T3_ROUTE_MOUNT'
  | 'T3_START_FLOW_BEGIN'
  | 'T3_WS_CONNECTED'
  | 'T3_AUTH_OK'
  | 'T3_TOPIC_REQUEST_SENT'
  | 'T3_TOPIC_RESPONSE_RECEIVED'
  | 'T3_INTRO_AUDIO_STARTED'
  | 'T3_INTRO_AUDIO_ENDED'
  | 'T3_TOPIC_AUDIO_STARTED';

export type SpeakingLatencySnapshot = {
  task: 'task1' | 'task3';
  marker: SpeakingLatencyMarker;
  tMs: number;
  sessionId?: string;
  metrics?: Record<string, number>;
};

const snapshots: SpeakingLatencySnapshot[] = [];

export function resetSpeakingLatencySnapshots(): void {
  snapshots.length = 0;
}

export function getSpeakingLatencySnapshots(): readonly SpeakingLatencySnapshot[] {
  return snapshots;
}

export function markSpeakingLatency(
  snapshot: Omit<SpeakingLatencySnapshot, 'tMs'> & { tMs?: number },
): number {
  const tMs = snapshot.tMs ?? Date.now();
  const entry: SpeakingLatencySnapshot = { ...snapshot, tMs };
  snapshots.push(entry);
  const metrics = entry.metrics ? ` ${JSON.stringify(entry.metrics)}` : '';
  console.info(`[speaking-perf] ${entry.task} ${entry.marker} @${tMs}${metrics}`);
  return tMs;
}

export function computeLatencyMs(fromMs: number, toMs: number): number {
  return Math.max(0, toMs - fromMs);
}
